<img
    *ngIf="emailAddress$ | async as emailAddress"
    class="profile__avatar"
    ngxGravatar
    [email]="emailAddress"
    [round]="true"
    [size]="size"
    [fallback]="useBlankFallback ? 'blank' : 'retro'"
/>
